<template>

  <div class="vue user-cluster-component col-12" v-if="user.enable_user_cluster">
    <div class="container" id="aspirazionalita" :style="border ? 'border:1px solid #01FEF3' : ''">
      <div class="row">
        <div class="col-12 bg-dark text-white py-md-3 pt-3 pt-1" :class="!profile && isEnabled ? ' col-md-7 ' : ''">
          <div class="row">
            <div class="col-12 d-flex align-items-center justify-content-center" :class="!profile ? ' col-md-6' : ' col-md-5'">

              <img :src="user.cluster_image" :alt="user.cluster_name" class="cluster-image mr-4">
              <h5 class="d-inline-block text-white">
                <strong>
                  Sei un cliente <br>
                  <strong class="text-accent" :style=" user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' ">{{ user.cluster_name }}</strong> <br>
                  <span class="mt-2">{{ user.loyalty_line }}</span>
                </strong>
              </h5>

            </div>
            <div class="col-10 offset-1 d-md-none d-flex align-items-center separe-accent my-2" v-if="!profile"></div>
            <div class="col-12 d-md-none d-flex align-items-center my-2 px-0" v-else>
              <img :src="themePath('images/aspirazionalita-arrow-down.png')" style="max-width: 100%">
            </div>
            <div class="col-md-1 d-none d-md-flex align-items-center py-1 my-3">
              <img :src="themePath('images/aspirazionalita-arrow.png')" style="max-height: 46px">
            </div>
            <div class="col-12 d-flex align-items-center px-0 mb-2" :class="!profile ? 'col-md-4' : 'col-md-6'">
              <div class="text-center align-items-center col-12">
                <div :class="'col-12'">
                  <div class="col-md-12 d-none d-md-flex text-left px-0"><strong class="font-title">PARTY DELLA DOMENICA</strong></div>
                  <div class="col-md-12 d-none d-md-flex text-left px-0">
                    <span :style="user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' " v-text="user.cluster_attempts + attempts(user.cluster_attempts).attempt"></span>
                  </div>
                  <div class="text-center d-md-none">
                    <strong class="font-title " :class="!profile ? 'mx-2' : ''">PARTY DELLA DOMENICA</strong>
                    <br>
                    <span :style="user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' " v-text="user.cluster_attempts + attempts(user.cluster_attempts).attempt"></span>
                  </div>
                </div>
<!--                <div class="col-7 px-0" v-if="profile">-->
<!--                  <div class="col-md-12 d-none d-md-flex text-left"><strong class="font-title">PARTY DELLA DOMENICA</strong></div>-->
<!--                  <div class="col-md-12 d-none d-md-flex text-left">-->
<!--                    <span :style="user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' " v-text="user.cluster_attempts + attempts(user.cluster_attempts).play"></span>-->
<!--                  </div>-->
<!--                  <div class="text-center d-md-none">-->
<!--                    <strong class="font-title " :class="!profile ? 'mx-2' : ''">PARTY DELLA DOMENICA</strong>-->
<!--                    <br v-if="profile">-->
<!--                    <span :style="user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' " v-text="user.cluster_attempts + attempts(user.cluster_attempts).play"></span>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
<!--              <div class="row text-left" v-if="profile">-->
<!--                <div class="col-md-12 d-none d-md-flex text-left"><strong>PARTY DELLA DOMENICA</strong></div>-->
<!--                <div class="col-md-12 d-none d-md-flex text-left">-->
<!--                  <span :style="user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' " v-text="user.cluster_attempts + attempts(user.cluster_attempts).play"></span>-->
<!--                </div>-->
<!--                <div class="text-center d-md-none">-->
<!--                  <strong :class="!profile ? 'mx-2' : ''">PARTY DELLA DOMENICA</strong>-->
<!--                  <br v-if="profile">-->
<!--                  <span :style="user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' " v-text="user.cluster_attempts + attempts(user.cluster_attempts).play"></span>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>

        <div class="col-12 badge-accent py-3 justify-content-center align-items-center" :class="!profile && isEnabled ? ' col-md-5 d-flex' : 'd-none'">
          <div class="row">
            <div class="col-md-6 col-12 d-flex justify-content-center align-items-center text-md-left">
              <strong>Vuoi avere più possibilità di vincita e aumentare i vantaggi?</strong>
            </div>
            <div class="col-md-6 col-8 offset-2 offset-md-0 mt-1 mt-md-0 d-flex justify-content-center align-items-center pl-md-0">
              <a href="#fisso-mobile" target="_self" class="btn btn-primary btn-block no-border">SCOPRI COME FARE</a>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */

import TimPartyMixin from '../mixins/TimPartyMixin';

export default {
  name: "UserCluster",
  mixins: [TimPartyMixin],
  props: {
    border: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {}
  },
  mounted: function () {
  },
  methods: {
    attempts: function (number_attempts) {
      return number_attempts == '1' ? {'attempt':' tentativo', 'play': ' giocata' }: {'attempt':' tentativi', 'play': ' giocate' };
    },
  },
  computed: {
    isEnabled: function(){
      return ( this.user.cluster && this.user.cluster != 'GUEST_STAR');
    },
  },
  watch: {
    user: function () {
      console.log('this.user', this.user);
    }
  }
}
</script>
